import {
  ODataQuery,
  ODataReadInfiniteOptions,
  useODataReadInfiniteApi,
} from '@msrceng/component';
import { useEndpoint } from 'api/useEndpoint';
import { Acknowledgement } from '../../types';

/** Get an infinitely growing list of Affected Product items */
export const useAcknowledgementInfiniteApi = (
  oQuery?: ODataQuery,
  options?: ODataReadInfiniteOptions<Acknowledgement>
) => {
  const endpoint = useEndpoint('/acknowledgement');
  return useODataReadInfiniteApi<Acknowledgement>(endpoint, oQuery, {
    isAuthRequired: false,
    isVerificationRequired: false,
    ...options,
  });
};
